import { defineComponent } from 'vue'
import type { PropType, ExtractPropTypes } from 'vue'


export const pagetableColumnDateProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  bodyAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],
  tail: [Boolean, String],

  // Date
  format: String,
  sourceFormat: String,
})

export type PagetableColumnDateProps = Partial<ExtractPropTypes<ReturnType<typeof pagetableColumnDateProps>>>

export default defineComponent({
  name: 'OPagetableColumnDate',
  inheritAttrs: false,
  props: pagetableColumnDateProps(),
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
